import { motion } from 'framer-motion'
import { 
  EyeOutlined, 
  RobotOutlined, 
  SafetyOutlined, 
  ThunderboltOutlined,
  ExperimentOutlined,
  GlobalOutlined
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const Features = () => {
  const { t } = useTranslation()
  
  const features = [
    {
      icon: <EyeOutlined />,
      title: t('features.objectDetection.title'),
      description: t('features.objectDetection.description'),
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: <RobotOutlined />,
      title: t('features.imageSegmentation.title'),
      description: t('features.imageSegmentation.description'),
      color: 'from-purple-500 to-pink-500',
    },
    {
      icon: <SafetyOutlined />,
      title: t('features.defectDetection.title'),
      description: t('features.defectDetection.description'),
      color: 'from-green-500 to-teal-500',
    },
    {
      icon: <ThunderboltOutlined />,
      title: t('features.ocrRecognition.title'),
      description: t('features.ocrRecognition.description'),
      color: 'from-orange-500 to-red-500',
    },
    {
      icon: <ExperimentOutlined />,
      title: t('features.deepLearning.title'),
      description: t('features.deepLearning.description'),
      color: 'from-indigo-500 to-blue-500',
    },
    {
      icon: <GlobalOutlined />,
      title: t('features.edgeComputing.title'),
      description: t('features.edgeComputing.description'),
      color: 'from-cyan-500 to-green-500',
    },
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="section-title">{t('features.title')}</h2>
          <p className="section-subtitle">
            {t('features.subtitle')}
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ y: -10 }}
              className="card p-8 relative overflow-hidden group"
            >
              {/* 背景渐变效果 */}
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-full blur-2xl`} />
              
              <div className="relative z-10">
                <div className={`w-16 h-16 rounded-lg bg-gradient-to-br ${feature.color} flex items-center justify-center mb-6 text-white text-3xl`}>
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

export default Features

